import OrganisationAgencyCodes from "./organisationAgencyCodes"

export { default as OrganisationAgencyCodesPanel } from "./organisationAgencyCodes.panel"
export default OrganisationAgencyCodes
